// Reducer for rediscover actions

import * as ActionTypes from '../constants/action_types'
import { CONTENT_INTELLIGENCE, CATALOG_ANALYSIS, PERFORMANCE_ANALYSIS, AI_INSIGHTS } from '../constants/commons'

export const DefaulSidebarState = {
  selectedNav: '',
  isContentIntelligence: true,
  isCatalogAnalysis: true,
  isPerformanceAnalysis: true,
  isAIInsights: true
}

export const sidebar = (state = DefaulSidebarState, action) => {
  switch (action.type) {
    case ActionTypes.SIDEBAR_SELECTED_NAV:
      return {
        ...state,
        selectedNav: action.nav,
        isContentIntelligence: action.nav === CONTENT_INTELLIGENCE ? !state.isContentIntelligence : state.isContentIntelligence,
        isCatalogAnalysis: action.nav === CATALOG_ANALYSIS? !state.isCatalogAnalysis : state.isCatalogAnalysis,
        isPerformanceAnalysis: action.nav === PERFORMANCE_ANALYSIS ? !state.isPerformanceAnalysis : state.isPerformanceAnalysis,
        isAIInsights: action.nav === AI_INSIGHTS ? !state.isAIInsights : state.isAIInsights
      }
    default:
      return state
    }
}